<div class="py-4 container-fluid teach-compensation-review-page">
  <h4 class="mb-4 teach-compensation-review-title">
    การจัดการคำขอสอนชดเชย - ตรวจสอบและอนุมัติคำขอสอนชดเชย
  </h4>

  <div class="teach-compensation-review-card">
    <div class="teach-compensation-review-card-body">
      <div class="teach-compensation-review-toolbar" [formGroup]="form">
        <div class="teach-compensation-review-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="teach-compensation-review-select"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="teach-compensation-review-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="year"
            [options]="yearOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="teach-compensation-review-select"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="teach-compensation-review-search">
          <app-filter-search-input
            label="ตำแหน่งทางวิชาการ, ชื่อ - นามสกุล"
            formControlName="keywords"
            inputClass="teach-compensation-review-search-input"
            classes="mb-0"
            ariaLabel="ค้นหาคำขอสอนชดเชย"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>

        <div class="teach-compensation-review-filter">
          <app-select
            label="สาขาวิชา"
            formControlName="departmentId"
            [options]="departmentOptions"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            [clearable]="true"
            inputClass="teach-compensation-review-select"
            classes="mb-0"
          ></app-select>
        </div>
      </div>

      <div class="segmented-tabs segmented-tabs--sm teach-compensation-review-tabs" role="tablist" aria-label="สถานะคำขอสอนชดเชย">
<button [attr.aria-selected]="activeTab() === 'all'" role="tab"
          type="button"
          class="segmented-tab teach-compensation-review-tab"
          [class.active]="activeTab() === 'all'"
          (click)="onTabChange('all')"
        >
          รายการทั้งหมด
        </button>
<button [attr.aria-selected]="activeTab() === 'pending'" role="tab"
          type="button"
          class="segmented-tab teach-compensation-review-tab"
          [class.active]="activeTab() === 'pending'"
          (click)="onTabChange('pending')"
        >
          รอดำเนินการ
        </button>
<button [attr.aria-selected]="activeTab() === 'approved'" role="tab"
          type="button"
          class="segmented-tab teach-compensation-review-tab"
          [class.active]="activeTab() === 'approved'"
          (click)="onTabChange('approved')"
        >
          อนุมัติแล้ว
        </button>
<button [attr.aria-selected]="activeTab() === 'rejected'" role="tab"
          type="button"
          class="segmented-tab teach-compensation-review-tab"
          [class.active]="activeTab() === 'rejected'"
          (click)="onTabChange('rejected')"
        >
          ไม่อนุมัติ
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="teach-compensation-review-status-badge"
          [class.teach-compensation-review-status-badge-pending]="row.status === 'submitted' || row.status === 'draft'"
          [class.teach-compensation-review-status-badge-approved]="row.status === 'approved'"
          [class.teach-compensation-review-status-badge-rejected]="row.status === 'rejected'"
          [class.teach-compensation-review-status-badge-revision]="row.status === 'revision_requested'"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="teach-compensation-review-actions">
          <button
            type="button"
            class="btn teach-compensation-review-action-button datatable-view-action-button"
            aria-label="ดูคำขอสอนชดเชย"
            (click)="onView(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="teach-compensation-review-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="teach-compensation review pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

@if (isDetailModalOpen()) {
  <div
    class="teach-compensation-review-modal-overlay"
    role="presentation"
  >
    <div
      class="teach-compensation-review-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="teachCompensationReviewDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="teach-compensation-review-detail-header">
          <h5 id="teachCompensationReviewDetailTitle">ข้อมูลคำขอสอนชดเชย</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="ปิด"
            (click)="onCloseModal()"
          ></button>
        </div>

        <div class="teach-compensation-review-detail-body">
          <section class="teach-compensation-review-detail-section">
            <h6>รายละเอียดผู้สอน</h6>
            <div class="teach-compensation-review-detail-grid">
              <p><strong>ชื่อ - นามสกุล :</strong> {{ row.teacherName }}</p>
              <p><strong>สาขาวิชา :</strong> {{ row.department }}</p>
            </div>
          </section>

          <section class="teach-compensation-review-detail-section">
            <h6>รายละเอียดการลา/หยุด</h6>
            <div class="teach-compensation-review-detail-grid">
              <p><strong>ประเภทการลา/หยุด :</strong> {{ row.raw.makeup_teaching_leave_type?.name ?? '-' }}</p>
              <p><strong>วันที่ลา :</strong> {{ formatDetailDate(row.raw.leave_date) }}</p>
              <p><strong>ช่วงเวลาการลา :</strong>
                @if (row.raw.makeup_teaching_leave_period; as leavePeriod) {
                  {{ leavePeriod.name ?? '-' }}
                  @if (leavePeriod.start_time && leavePeriod.end_time) {
                    ({{ formatDetailTimeRange(leavePeriod.start_time, leavePeriod.end_time) }})
                  }
                } @else {
                  -
                }
              </p>
            </div>
          </section>

          <section class="teach-compensation-review-detail-section">
            <h6>รายละเอียดรายวิชา</h6>
            <div class="teach-compensation-review-detail-grid">
              <p><strong>ชื่อรายวิชา :</strong> {{ getSelectedSubjectName(row) }}</p>
              <p><strong>รหัสวิชา :</strong> {{ getSelectedSubjectCode(row) }}</p>
              <p><strong>หลักสูตร :</strong> {{ getSelectedCurriculum(row) }}</p>
              <p><strong>ประเภทการสอน :</strong> {{ getSelectedStudyMode(row) }}</p>
              <p><strong>ค่าหน่วยกิต :</strong> {{ getSelectedCourseUnit(row) }}</p>
              <p><strong>วันที่สอน :</strong> {{ getTeachingDays(row) }}</p>
              <p><strong>เวลาสอน :</strong> {{ getTeachingTimes(row) }}</p>
              <p><strong>ชั่วโมงที่สอน :</strong> {{ getTeachingHours(row) }}</p>
            </div>
          </section>

          <section class="teach-compensation-review-detail-section">
            <h6>รายละเอียดสอนชดเชย</h6>
            <div class="teach-compensation-review-detail-grid">
              <p><strong>วันที่ขอสอนชดเชย :</strong> {{ formatDetailDate(row.raw.makeup_teaching_date) }}</p>
              <p><strong>เวลาสอนชดเชย :</strong> {{ formatDetailTimeRange(row.raw.makeup_start_time?.label ?? row.raw.makeup_start_time?.time_value, row.raw.makeup_end_time?.label ?? row.raw.makeup_end_time?.time_value) }}</p>
              <p class="teach-compensation-review-detail-full"><strong>คำอธิบาย :</strong> {{ row.raw.description || '-' }}</p>
            </div>
          </section>
        </div>

        <div class="teach-compensation-review-detail-footer">
          <div class="teach-compensation-review-action-messages" aria-live="polite">
            @if (row.status === 'submitted') {
              @if (getDisplayedBlockedReason(row); as blockedReason) {
                <p id="teach-compensation-review-blocked-reason" class="teach-compensation-review-blocked-reason">
                  {{ blockedReason }}
                </p>
              }
            }
            @if (actionError() !== null) {
              <p class="teach-compensation-review-blocked-reason">
                {{ actionError() }}
              </p>
            }
          </div>
          <button
            type="button"
            class="teach-compensation-review-reject-button"
            [hidden]="row.status !== 'submitted'"
            [disabled]="isActionProcessing() || !row.canReject"
            [attr.aria-describedby]="!row.canReject && getDisplayedBlockedReason(row) !== null ? 'teach-compensation-review-blocked-reason' : null"
            (click)="onOpenReject()"
          >
            {{ rejecting() ? 'กำลังดำเนินการ...' : 'ไม่อนุมัติ' }}
          </button>
          <button
            type="button"
            class="teach-compensation-review-approve-button"
            [hidden]="row.status !== 'submitted'"
            [disabled]="isActionProcessing() || !row.canApprove"
            [attr.aria-describedby]="!row.canApprove && getDisplayedBlockedReason(row) !== null ? 'teach-compensation-review-blocked-reason' : null"
            (click)="onOpenApproveConfirm()"
          >
            {{ approving() ? 'กำลังอนุมัติ...' : 'อนุมัติ' }}
          </button>
        </div>
      }
    </div>
  </div>
}

@if (isRejectModalOpen()) {
  <div
    class="teach-compensation-review-modal-overlay teach-compensation-review-reject-overlay"
    role="presentation"
  >
    <section
      class="teach-compensation-review-modal-panel teach-compensation-review-reject-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="teachCompensationReviewRejectTitle"
    >
      <header class="teach-compensation-review-detail-header">
        <h5 id="teachCompensationReviewRejectTitle">เหตุผลที่ไม่อนุมัติคำขอสอนชดเชย</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิด"
          [disabled]="rejecting()"
          (click)="onCloseReject()"
        ></button>
      </header>

      <form
        class="teach-compensation-review-reject-form"
        [formGroup]="rejectForm"
        (ngSubmit)="onConfirmReject()"
      >
        <app-textarea
          label="เหตุผล"
          formControlName="comment"
          [rows]="5"
          [required]="true"
          [error]="rejectForm.controls['comment'].invalid && rejectForm.controls['comment'].touched ? rejectForm.controls['comment'].errors : null"
          classes="mb-0"
        ></app-textarea>

        @if (actionError() !== null) {
          <p class="teach-compensation-review-blocked-reason" aria-live="polite">
            {{ actionError() }}
          </p>
        }

        <footer class="teach-compensation-review-reject-footer">
          <button
            type="button"
            class="btn teach-compensation-review-reject-back-button"
            [disabled]="rejecting()"
            (click)="onCloseReject()"
          >
            ยกเลิก
          </button>
          <button
            type="submit"
            class="btn teach-compensation-review-reject-submit-button"
            [disabled]="rejecting() || rejectForm.invalid"
          >
            {{ rejecting() ? 'กำลังดำเนินการ...' : 'ยืนยันไม่อนุมัติ' }}
          </button>
        </footer>
      </form>
    </section>
  </div>
}

<app-confirm-dialog
  #approveConfirmDialog
  modalId="teachCompensationReviewApproveConfirmDialog"
  icon="warning"
  title="ยืนยันการอนุมัติคำขอสอนชดเชย"
  message="ต้องการอนุมัติคำขอสอนชดเชยนี้หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="อนุมัติ"
  [isProcessing]="approving()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmApprove()"
></app-confirm-dialog>

<app-confirm-dialog
  #approveSuccessDialog
  modalId="teachCompensationReviewApproveSuccessDialog"
  icon="success"
  title="อนุมัติคำขอสอนชดเชยสำเร็จ"
  message="ดำเนินการอนุมัติคำขอสอนชดเชยสำเร็จ"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="approveSuccessDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #rejectSuccessDialog
  modalId="teachCompensationReviewRejectSuccessDialog"
  icon="success"
  title="ไม่อนุมัติคำขอสอนชดเชยสำเร็จ"
  message="ดำเนินการไม่อนุมัติคำขอสอนชดเชยสำเร็จ"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="rejectSuccessDialog.close()"
></app-confirm-dialog>
